const UUID_STARGAZER_RESOURCE = "3d282485-64e4-4b6e-96f1-be43283e29b4";
const UUID_STARGAZER_HIDDEN = "1995c591-9770-4cec-9c57-93c2a0a2fd0e";
const UUID_STARGAZER_TEXT = "d1913cf5-494a-4fdc-a0cd-1c6d9c908a28";
const UUID_STARGAZER_EVENT = "d1913cf5-494a-4fdc-a0cd-1c6d9c908a29";
const UUID_CONFIG = "d1913cf5-494a-4fdc-a0cd-1c6d9c908a2a";
const UUID_STARGAZER_COMPILE = "d1913cf5-494a-4fdc-a0cd-1c6d9c908a27";
/**
 * @internal
 */
export const UUID_STARGAZER_LOADER = "711dc75f-9b29-4a29-bb81-9ed27a5f425a";
/**
 * @internal
 */
export const REGISTRY_ELEMENT = Symbol.for(UUID_STARGAZER_RESOURCE);
/**
 * @internal
 */
export const RESOURCE_HIDDEN = Symbol.for(UUID_STARGAZER_HIDDEN);
/**
 * @internal
 */
export const RESOURCE_LOADER = Symbol.for(UUID_STARGAZER_LOADER);
/**
 * @internal
 */
export const RESOURCE_TEXT = Symbol.for(UUID_STARGAZER_TEXT);
/**
 * @internal
 */
export const RESOURCE_EVENT = Symbol.for(UUID_STARGAZER_EVENT);
/**
 * @interal
 */
export const RESOURCE_CONFIG = Symbol.for(UUID_CONFIG);
export const RESOURCE_COMPILE = Symbol.for(UUID_STARGAZER_COMPILE);
export const RENDERED_ELEMENTS = Symbol();
export const RENDERED_TEXTNODES = Symbol();
/**
 * @typedef {HTMLTemplateElement & {
 *   [RESOURCE_HIDDEN]?: boolean;
 *   [RESOURCE_LOADER]?: ResourceLoader | null;
 *   [RESOURCE_TEXT]?: boolean;
 *   [RESOURCE_EVENT]?: boolean;
 *   [RESOURCE_COMPILE]?: Promise<any>;
 *   [RESOURCE_CONFIG]?: Array<ConfigCallback>;
 * }} ResourceElement
 */
/**
 * @typedef {HTMLTemplateElement & {
 *  [RENDERED_TEXTNODES]: Record<string, Text>;
 *  [RENDERED_ELEMENTS]: Record<string, Element>;
 * }} RenderedResourceElement
 */
/**
 * @callback ConfigCallback
 * @param {ResourceElement} resource
 * @returns {void | boolean}
 */
/**
 * @callback ResourceLoader
 * @param {string[]} path
 * @param {(result: Document | Element | Object) => void} insert
 * @returns {Promise<void>}
 */
